var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"setmeal"},[(_vm.isWeixin_status == false)?_c('NavBar',{attrs:{"fixed":"","left-arrow":"","title":"礼品卡"},on:{"click-left":_vm.goBack}}):_vm._e(),_c('img',{attrs:{"src":require("@static/home/giftcard.jpg"),"alt":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }